import React from 'react';

const CompanySelectionButtons = React.memo(({ companies, onSelect }) => {
  return (
    <div style={{ 
      marginTop: '1rem',
      display: 'flex',
      flexWrap: 'wrap',
      gap: '0.75rem'
    }}>
      {companies.map((company) => (
        <button
          key={company.companyId}
          onClick={() => onSelect(company)}
          style={{
            padding: '0.75rem 1.25rem',
            backgroundColor: '#4F7CFF',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '0.875rem',
            fontWeight: '500',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '0.25rem',
            transition: 'all 0.2s ease',
            minWidth: '200px'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#3b5998';
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#4F7CFF';
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = 'none';
          }}
        >
          <div style={{ fontWeight: '600', fontSize: '0.95rem' }}>
            {company.companyName}
          </div>
          {company.location && company.location !== 'All Locations' && (
            <div style={{ fontSize: '0.75rem', opacity: 0.9 }}>
              {company.location}
            </div>
          )}
        </button>
      ))}
    </div>
  );
});

export default CompanySelectionButtons;